import { Outlet, useLocation } from 'react-router-dom';
import { ModalProvider } from '../../components/Modal/modalContext';
import WishlistButton from '../../components/Wishlist/WishlistButton';
import MainNavigation from '../../components/MainNavigation/MainNavigation';
import styles from './../header.module.scss';
import { GlobalContext } from './GlobalContext';
import React, { createContext, useEffect, useState } from 'react';
import Footer from 'components/Footer/Footer';
import Aos from 'aos';
import { ScrollToTop } from '../../functions';
import MenuTiles from '../../components/MenuTiles/MenuTiles';

export const DataContext = createContext({});

function RootLayout({ json }) {
  const initialContext = {
    menuTilesStructure: null,
  };
  const [context, setContext] = useState(initialContext);
  // const [allImagesLoaded, setAllImagesLoaded] = useState(false);

  useEffect((_) => {
    // console.log('root layout', json);
    Aos.init({
      duration: 1,
      // duration:3000,
      once: false,
    });

    const productsVariant = JSON.parse(localStorage.getItem('variant'));
    if (!productsVariant) localStorage.setItem('variant', JSON.stringify('low'));

    localStorage.setItem = (key, value) => {
      localStorage[key] = value;

      const event = new Event('itemInserted');
      document.dispatchEvent(event);
    };
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   // if not a hash link, scroll to top
  //   if (hash === '') {
  //     window.scrollTo(0, 0);
  //   }
  //   // else scroll to id
  //   else {
  //     const imageLoadedHandler = (event) => {
  //       const allLoadedImages = document.querySelectorAll('[data-image-loaded=true]');
  //       console.log("all images: ", allLoadedImages, images)
  //       if (allLoadedImages.length + 1 >= images.length) {
  //         setAllImagesLoaded(true);
  //       }
  //       event.target.setAttribute('data-image-loaded', true);
  //     };
  //
  //     const images = document.querySelectorAll('img');
  //
  //     if (!images) {
  //       setTimeout(() => {
  //         setAllImagesLoaded(true);
  //       }, 0);
  //     } else {
  //       images.forEach((image) => image.addEventListener('load', imageLoadedHandler));
  //     }
  //     return (_) => {
  //       if (!!images) {
  //         images.forEach((image) => image.removeEventListener('load', imageLoadedHandler));
  //       }
  //       setAllImagesLoaded(false);
  //     };
  //   }
  // }, [pathname, hash, key]);
  //
  // useEffect(
  //   (_) => {
  //     const scrollToSection = (_) => {
  //       const id = hash.replace('#', '');
  //       const element = document.getElementById(id);
  //       if (element) {
  //         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       }
  //     };
  //     console.log("iffff images loadded")
  //
  //     if (allImagesLoaded) {
  //       console.log("images loadded")
  //       setTimeout(() => {
  //         scrollToSection();
  //       }, 500);
  //     }
  //   },
  //   [allImagesLoaded]
  // );

  return (
    <>
      <DataContext.Provider value={json}>
        <GlobalContext.Provider value={{ context, setContext }}>
          <header>
            <MainNavigation />
            <ModalProvider>
              <WishlistButton customClassName={styles.wishlistButton} />
            </ModalProvider>
          </header>
          <Outlet />
          {/*<Footer />*/}
        </GlobalContext.Provider>
      </DataContext.Provider>
      <div id="modal-root"></div>
      <div id="lightbox-root"></div>
    </>
  );
}

export default RootLayout;
